import Addon from '../../../../shared/classes/addon';
import DescriptionAddonPriceText from '@components/atoms/text/descriptionAddonPriceText';
import TranslationManager from '../../../../shared/assets/locale/translationsManager';

interface Props {
  asset: Addon;
}

export default function DescriptionAddonPrice({ asset }: Props) {
  return asset?.price ? (
    <DescriptionAddonPriceText>
      {TranslationManager.get('PAGES.ADDON.FOR_ONLY')}
      <br></br>
      {asset?.price?.monthly
        ? TranslationManager.get(
            'PAGES.ADDON.PROMO_PRICE_MONTH',
            asset?.price?.monthly?.toString() || undefined
          )
        : null}
      {asset?.price?.monthly && asset?.price?.annually
        ? TranslationManager.get(
            'PAGES.ADDON.PROMO_PRICE_CONJUNCTION',
            asset?.price?.annually?.toString() || undefined
          )
        : null}
      {asset?.price.annually
        ? TranslationManager.get(
            'PAGES.ADDON.PROMO_PRICE_YEAR',
            asset?.price?.annually?.toString() || undefined
          )
        : null}
    </DescriptionAddonPriceText>
  ) : null;
}
